<template>
    <div>
        <icon name="car-side" v-if="item.value.notEndedOrdersCount" v-b-tooltip.hover :title="'Количество активных заказов: ' + item.value.notEndedOrdersCount"></icon>
        <icon name="people-carry" v-if="item.item.courier === 'Самовывоз'"></icon>
        <b-badge v-if="getItemType(item.item) === 'order'" :variant="getOrderBadgeVariant(item.item.order.status.keyword)" class="order-row__status stage">{{item.item.order.status.name}}</b-badge>
        <b-badge v-if="getItemType(item.item) === 'order' && item.item.order.autoAssignCourier" class="order-row__status">Назначено автоматически</b-badge>
        {{ getOrderTitle(item.item) }}
    </div>
</template>

<script>
import orderFunc from '@/functionsLib/orderFunc'
export default {
  name: 'OrderRow',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    getOrderTitle (item) {
      if (this.getItemType(item) === 'courier') {
        return this.fullNameWorker(item.courier) + ' (' + item.courier.phoneNumber + ')'
      } else if (this.getItemType(item) === 'pickup') {
        return 'Самовывоз'
      } else {
        return 'Заказ № ' + item.order.idDay
      }
    },
    getItemType (item) {
      if (item.courier && item.courier !== 'Самовывоз') {
        return 'courier'
      } else if (item.courier === 'Самовывоз') {
        return 'pickup'
      } else {
        return 'order'
      }
    },
    getOrderBadgeVariant (keyword) {
      switch (keyword) {
        case 'in_delivery':
          return 'warning'
        case 'ended':
          return 'success'
        case 'passed':
          return 'info'
      }
    },
    fullNameWorker: orderFunc.fullNameWorker
  }
}
</script>

<style lang="scss" scoped>
    .order-row__status {
        padding: 4px 10px;
        .stage {
          cursor: pointer;
          width: 90px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ordersDelivery/OrderRow.vue